export var REPORTS_SHARING_PATH_PREFIX = "/reports";
export var REPORTS_LIST_PATH = "".concat(REPORTS_SHARING_PATH_PREFIX, "/:reportTermPath/:reportTypePath");
export var REPORT_DETAIL_PAGE_PATH = "".concat(REPORTS_SHARING_PATH_PREFIX, "/:reportTermPath/:reportTypePath/:reportId");

//# sourceMappingURL=routes.js.map